<div class="fixed bottom-5 right-5">
  <button
    class="daisy-btn daisy-btn-circle daisy-btn-primary"
    (click)="togglePanel()"
    >
    📤
    <span class="daisy-badge daisy-badge-secondary">{{
      (uploads$ | async)?.length || 0
    }}</span>
  </button>

  @if (isOpen) {
    <div
      class="absolute bottom-14 right-0 w-72 daisy-bg-white daisy-shadow-lg daisy-p-4 daisy-rounded-lg daisy-border daisy-border-gray-200"
      >
      <div class="daisy-flex daisy-justify-between daisy-items-center daisy-mb-2">
        <h3 class="daisy-text-lg daisy-font-semibold">Active Uploads</h3>
        <button
          class="daisy-btn daisy-btn-xs daisy-btn-error"
          (click)="clearCompleted()"
          >
          ✖
        </button>
      </div>
      @for (upload of uploads$ | async; track upload) {
        <div class="daisy-mb-2">
          <div class="daisy-text-sm daisy-font-medium">{{ upload.file.name }}</div>
          <progress
            class="daisy-progress daisy-progress-primary daisy-w-full"
            [value]="upload.uploadProgress"
            max="100"
          ></progress>
          <div class="daisy-text-xs daisy-text-gray-600">
            {{ upload.uploadProgress }}% - {{ upload.uploadStatus }}
          </div>
        </div>
      }
    </div>
  }
</div>
